<script>
  import ViewCardBase from "./ViewCardBase.svelte";
  import {translate} from "../../../i18n/i18next.js";
  import HelpTooltip from "../../tooltip/HelpTooltip.svelte";

  export let href
</script>

<ViewCardBase
  viewIconSrc="/assets/icons/icon_customized_res_gantt.png"
  href={href}
>
  <span style="display: inline-flex;">
    <span style="display: inline-flex; flex-wrap: wrap; justify-content: center">
      {translate("mySchedule.views.resGantt.name")}
      <span style='font-size: .8rem'>({translate("mySchedule.views.customizedResGantt.subName")})</span>
    </span>
    <span style="flex-shrink: 0; align-self: start">
      <HelpTooltip
        title={translate("mySchedule.views.customizedResGantt.name")}
        linkHref={translate("frontend:help.views.customizedResGantt.descriptionHref")}
      >
        {translate("frontend:help.views.customizedResGantt.description")}
      </HelpTooltip>
    </span>
  </span>
</ViewCardBase>
